module.exports = __webpack_public_path__ + "img/website-store-tiles-01-2_low_matted-frames.a1e0b68f.jpeg";